import { render, staticRenderFns } from "./promotion-setting-aside-form.component.vue?vue&type=template&id=fa64d9cc&scoped=true"
import script from "./promotion-setting-aside-form.component.vue?vue&type=script&lang=ts"
export * from "./promotion-setting-aside-form.component.vue?vue&type=script&lang=ts"
import style0 from "./promotion-setting-aside-form.component.vue?vue&type=style&index=0&id=fa64d9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa64d9cc",
  null
  
)

export default component.exports